import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyCreateAssessment = lazyWithRetry(() => import("./CreateAssessment"));

const CreateAssessment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyCreateAssessment {...props} />;

export default CreateAssessment;
